import {
  GET_PUBLICATION_SCHEDULE_REQUEST,
  GET_PUBLICATION_SCHEDULE_SUCCESS,
  GET_PUBLICATION_SCHEDULE_FAILURE,
} from "../actions/publicationScheduleActions";

const initialState = {
  schedule: [],
  ticketId: null,
  tenantId: null,
  loading: false,
  error: null,
};

const publicationScheduleReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PUBLICATION_SCHEDULE_REQUEST:
      return { ...state, loading: true, error: null };

    case GET_PUBLICATION_SCHEDULE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        schedule: action.payload?.schedule || [],
        ticketId: action.payload?.ticketId || null,
        tenantId: action.payload?.tenantId || null,
      };

    case GET_PUBLICATION_SCHEDULE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload || "Failed to load publication schedule",
      };

    default:
      return state;
  }
};

export default publicationScheduleReducer;
